import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { AgentApi, type GenerateJobRequest } from '@/domains/agent/apis';
import { HomeMaterialApi } from '@/domains/home/apis/home-material-api';
import { ref } from 'vue';

export const useFormulationLegacy = () => {
  const homeMaterialApiService = injectService<HomeMaterialApi>(HomeMaterialApi);
  const agentApiService = injectService<AgentApi>(AgentApi);

  const formulationLegacyAgentId = ref(0);
  const formulationLegacyJobId = ref('');

  const getFormulationLegacyAgentId = async () => {
    if (!formulationLegacyAgentId.value) {
      const oldProducts = await homeMaterialApiService.getProducts();
      formulationLegacyAgentId.value =
        oldProducts.find((p) => p.function_id === 'material_formulation_package')?.agent_id || 0;
    }

    return formulationLegacyAgentId.value;
  };

  async function createFormulationLegacyChatJob(input: string) {
    if (!formulationLegacyJobId.value) {
      const payload: GenerateJobRequest = {
        input,
        agent_ids: [formulationLegacyAgentId.value],
        team_ids: [],
      };

      formulationLegacyJobId.value = (await agentApiService.chatJob(payload)).job_id;
    }

    (globalThis as unknown as { location: { href: string } }).location.href =
      `/ai/agent-flow/${formulationLegacyJobId.value}`;
  }

  async function submitFormulationLegacyPipeline(input: string) {
    await getFormulationLegacyAgentId();
    await createFormulationLegacyChatJob(input);
  }

  return {
    submitFormulationLegacyPipeline,
  };
};
